import { CommandBarButton, IconButton } from "@fluentui/react";
import React from "react";
import DetailsTable from "../../../../Table/DetailsTable";
import DefaultContextualMenu from "../../../../Table/DefaultContextualMenu";
import FeatureSummary from "../../../../Util/FeatureSummary";

const DefaultTable = ({
    cobrandDashboardTasks,
    editOnClick,
    deleteOnClick,
    createOnClick,
    setSelectedCobrandDashboardTask,
}) => {
    const columns = [
        {
            key: "toolbar",
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <DefaultContextualMenu
                    editOnClick={() => editOnClick(item.cobrandDashboardTaskId)}
                    deleteOnClick={() => deleteOnClick()}
                />
            ),
        },
        {
            name: "Id",
            fieldName: "cobrandDashboardTaskId",
            key: "cobrandDashboardTaskId",
            minWidth: 50,
            maxWidth: 50,
            isResizable: true,
            isSorted: true,
            isSortedDescending: false,
        },
        {
            name: "Cobrand",
            fieldName: "cobrandName",
            key: "cobrandName",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSortedDescending: false,
        },
        {
            name: "Dashboard Task Slug",
            fieldName: "dashboardTaskSlug",
            key: "dashboardTaskSlug",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSortedDescending: false,
        },
        {
            name: "Is Enabled",
            fieldName: "onOffDefault",
            key: "onOffDefault",
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isSortedDescending: false,
        },
    ];

    return (
        <>
        <DetailsTable
            items={cobrandDashboardTasks}
            columns={columns}
            mainColumn={"cobrandDashboardTaskId"}
            CommandBar={
                <>
                    <CommandBarButton iconProps={{ iconName: "Add" }} text="Add Dashboard Task" onClick={() => createOnClick()} />
                </>
            }
            selectionHook={(items) => setSelectedCobrandDashboardTask(items && items[0])}
        />
        <FeatureSummary
            label="About Dashboard Tasks"
            summary="This table displays dashboard tasks for cobrands. It is not a definitive list of all tasks, but rather those that have specific settings for cobrands. You can add, edit, or delete cobrand dashboard tasks to customize which tasks appear on user dashboards for each cobrand."
            imageUrlPath='dashboard-tasks'
        />
        </>
    );
};

export default DefaultTable;
